import { render, staticRenderFns } from "./yanzhengma.vue?vue&type=template&id=31f211ac&scoped=true&"
import script from "./yanzhengma.vue?vue&type=script&lang=js&"
export * from "./yanzhengma.vue?vue&type=script&lang=js&"
import style0 from "./yanzhengma.vue?vue&type=style&index=0&id=31f211ac&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31f211ac",
  null
  
)

export default component.exports